import type { PackagePriceMode } from './types';

type PricingInput = {
  fixedPrice: number;
  discountPercentage: number;
};

// Mirrors Pricing::ServicePackagePriceSetter so the modal's live preview
// matches what the backend will actually persist.
export const computeLinePrices = (
  originalPrices: number[],
  mode: PackagePriceMode,
  { fixedPrice, discountPercentage }: PricingInput,
): number[] => {
  if (mode === 'fixed') {
    const totalOriginal = originalPrices.reduce((sum, price) => sum + price, 0);
    let remaining = fixedPrice;
    const remainderIndex = originalPrices.reduce(
      (highestIndex, price, index) =>
        price > originalPrices[highestIndex] ? index : highestIndex,
      0,
    );

    const prices = originalPrices.map((originalPrice, index) => {
      if (index === remainderIndex) {
        return 0;
      }

      if (totalOriginal === 0) {
        return 0;
      }

      const allocated = Math.round(
        (fixedPrice * originalPrice) / totalOriginal,
      );
      remaining -= allocated;
      return allocated;
    });

    if (prices.length > 0) {
      prices[remainderIndex] = remaining;
    }
    return prices;
  }

  const discount = mode === 'percentage' ? discountPercentage : 0;
  return originalPrices.map((originalPrice) =>
    Math.round((originalPrice * (100 - discount)) / 100),
  );
};
